import { api } from "../client";
import type { TvDevice } from "../types";

export const tvApi = {
  claim: (code: string) => api<{ status: string; message: string; deviceId: string }>("tv/claim", { body: { code } }),
  /** Pre-register a clock being set up over Bluetooth (#374); the id goes to the clock. */
  provision: () => api<{ status: string; deviceId: string }>("tv/provision", { body: {} }),
  devices: () => api<{ status: string; devices: TvDevice[] }>("tv/devices", { method: "GET" }).then((r) => r.devices ?? []),
  unpair: (deviceId: string) =>
    api<{ status: string; message: string }>(`tv/devices/${encodeURIComponent(deviceId)}`, { method: "DELETE" }),
};
